<template>
  <div
    v-if="accounts && $login.can('accounts.view')"
    class="accounts-list"
  >
    <page-header header="Accounts">
      <router-link
        v-if="$login.can('accounts.create')"
        v-loading="loading"
        :to="{ name: 'accounts.create' }"
        class="ml-1 btn btn-primary "
      >
        Create Account
      </router-link>
    </page-header>
    <div class="py-3">
      <search v-model="params.search" />
      <vue-good-table
        class="mt-3"
        :columns="columns"
        styleClass="vgt-table"
        :rows="accounts"
        @on-row-click="({row}) => $router.push({name: 'accounts.view', params: { accountId : row.id}})"
      />
      <pagination
        :data="pagination"
        :disabled="loading"
        @change-page="(page) => { params.page = page }"
      />
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';

import axios from '@/axios'
import {createHttpQuery} from '@/helpers'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'

const getAccounts = async (params) => {
  try {
    const {data} = await axios.get('/accounts?populate[]=accountType', {params: createHttpQuery(params)})
    return data
  } catch (error) {
    throw new Error(error)
  }
}

const defaultPagination = () => {
  return {
    page: 1,
    search: null,
  }
}

export default {
  components: {
    VueGoodTable,
    Search,
    Pagination,
  },

  data () {
    return {
      accounts: [],
      pagination: null,
      loading: false,
      params: defaultPagination(),
      columns: [{
        label: 'Account',
        field: 'name',
      }, {
        label: 'Type',
        field: 'account_type.name'
      }],
    }
  },

  watch: {
    params: {
      deep: true,
      handler () {
        this.getData()
      },
    },
  },

  activated () {
    if (window.location.hash === '#fresh') {
      this.getData()
    }
  },

  metaInfo () {
    return {
      title: 'Accounts',
    }
  },

  mounted () {
    this.getData()
  },

  methods: {
    setData (_, accounts) {
      this.pagination = accounts.meta
      this.accounts = accounts.data
    },

    async getData () {
      if (!this.loading) {
        this.loading = true
        const response = await getAccounts(this.params)
        this.pagination = response.meta
        this.accounts = response.data
        this.loading = false
      }
    },
  },
}
</script>
